import { isEmojiCodePoint } from '@/utils/plainTextInput'

export const PROJECT_NAME_MAX_WEIGHT = 30
export const PROJECT_NAME_LIMIT_MESSAGE = '作品名称不能超过15个汉字或30个英文'
export const PROJECT_NAME_INVALID_CHAR_MESSAGE = '作品名称请不要使用 @ $ \\ / : * ? " < > |'
const PROJECT_NAME_INVALID_CHAR_PATTERN = /[@$\\/:*?"<>|]/u

function getCharWeight(char: string): number {
  return /[\u4e00-\u9fff]/u.test(char) ? 2 : 1
}

function isProjectNameCharAllowed(char: string): boolean {
  const cp = char.codePointAt(0)
  if (cp !== undefined && isEmojiCodePoint(cp)) return false
  return !PROJECT_NAME_INVALID_CHAR_PATTERN.test(char)
}

/**
 * 计算作品名称长度权重：汉字按 2，其他字符按 1。
 * @param value 作品名称。
 * @returns 长度权重。
 */
export function getProjectNameWeight(value: string): number {
  return Array.from(String(value || '')).reduce((total, char) => total + getCharWeight(char), 0)
}

/**
 * 判断作品名称是否满足 15 个汉字或 30 个英文的长度限制。
 * @param value 作品名称。
 * @returns true 表示名称可用。
 */
export function isProjectNameLengthValid(value: string): boolean {
  return getProjectNameWeight(value.trim()) <= PROJECT_NAME_MAX_WEIGHT
}

/**
 * 判断作品名称是否包含禁止字符。
 * @param value 作品名称。
 * @returns true 表示包含禁止字符。
 */
export function hasInvalidProjectNameChar(value: string): boolean {
  return Array.from(String(value || '')).some((char) => !isProjectNameCharAllowed(char))
}

/**
 * 截断作品名称到 15 个汉字或 30 个英文以内。
 * @param value 原始作品名称。
 * @returns 截断后的名称。
 */
export function truncateProjectName(value: string): string {
  let total = 0
  let result = ''
  for (const char of Array.from(String(value || ''))) {
    if (!isProjectNameCharAllowed(char)) continue
    const weight = getCharWeight(char)
    if (total + weight > PROJECT_NAME_MAX_WEIGHT) break
    total += weight
    result += char
  }
  return result
}
